import { useState, useEffect } from "react";
import axios from "axios";
import { Zap, X } from "lucide-react";
import { useLanguage } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LastMinuteBanner = () => {
  const { t, scrollTo } = useLanguage();
  const [offer, setOffer] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    axios.get(`${API}/last-minute`).then(({ data }) => {
      if (data.active) setOffer(data);
    }).catch(() => {});
  }, []);

  // Body class so Header can shift down when banner is visible
  useEffect(() => {
    const active = offer && !hidden;
    document.body.classList.toggle("ci-lm-active", Boolean(active));
    return () => document.body.classList.remove("ci-lm-active");
  }, [offer, hidden]);

  if (!offer || hidden) return null;

  const validDate = new Date(`${offer.valid_until}T12:00:00`);
  const dateStr = validDate.toLocaleDateString(undefined, { day: "numeric", month: "long" });

  return (
    <div
      data-testid="last-minute-banner"
      className="fixed top-0 left-0 right-0 z-[60] bg-[#C86D51] text-[#F8F5F0] px-6 py-2.5 flex items-center justify-between gap-3 shadow-[0_2px_10px_rgba(13,37,58,0.15)]"
      role="status"
    >
      <button
        onClick={() => scrollTo && scrollTo("prenota")}
        className="flex items-center gap-2 text-sm font-medium text-left"
        data-testid="last-minute-cta"
      >
        <Zap className="w-4 h-4 flex-shrink-0" />
        <span className="hidden sm:inline">{t.lastMinute.title}</span>
        <span className="font-semibold">
          {t.lastMinute.pill.replace("{pct}", offer.pct).replace("{date}", dateStr)}
        </span>
      </button>
      <button
        onClick={() => setHidden(true)}
        className="text-[#F8F5F0]/80 hover:text-white p-1"
        aria-label={t.lastMinute.close}
        data-testid="last-minute-close"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default LastMinuteBanner;
